// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"cc3517ae","531":"84a1af84","550":"3b6b980a","967":"2667cad5"}[chunkId] + ".chunk.js";
};